import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { api } from "@/lib/api";
import LoadCard from "@/components/LoadCard";
import PageHeader, { Empty } from "@/components/PageHeader";
import { t } from "@/lib/i18n";

const TABS = ["all", "open", "matched", "completed", "cancelled"];

export default function MyLoads() {
  const [loads, setLoads] = useState(null);
  const [tab, setTab] = useState("all");

  useEffect(() => { api.get("/loads/mine").then((r) => setLoads(r.data)); }, []);

  const shown = (loads || []).filter((l) => tab === "all" || l.status === tab);

  return (
    <div>
      <PageHeader kicker={t("Shipper console")} title={t("My Loads")}>
        <Link to="/post-load" className="hf-btn-primary" data-testid="btn-create-load-post"><Plus className="w-4 h-4" /> {t("Post a load · 1 credit")}</Link>
      </PageHeader>
      <div className="flex gap-1 mb-5 overflow-x-auto">
        {TABS.map((tb) => (
          <button key={tb} onClick={() => setTab(tb)} data-testid={`my-loads-tab-${tb}`}
            className={`h-9 px-4 rounded-full text-xs font-bold uppercase tracking-wider transition-colors ${tab === tb ? "bg-slate-900 text-white" : "bg-white border border-slate-200 text-slate-600 hover:bg-slate-50"}`}>
            {t(tb)} {loads && <span className="opacity-60">({(tb === "all" ? loads : loads.filter((l) => l.status === tb)).length})</span>}
          </button>
        ))}
      </div>
      <div className="space-y-3">
        {loads && shown.length === 0 && <Empty title={t("No loads here yet")} testId="my-loads-empty">{t("Post your first load to start receiving bids from verified transporters.")}</Empty>}
        {shown.map((l, i) => <LoadCard key={l.id} load={l} index={i} />)}
      </div>
    </div>
  );
}
